import { LinkButton } from '@cambridgeassessment/cambridge-ui';
import { buildNow } from '@cambridgeassessment/lib-ee-commons';
import React from 'react';
import { ExplanatoryText, StyledTooltip, useStyles } from './RerunSampleReport.styles';

interface Props {
  salgoStartDate: string;
  bufferDate: string;
  onDownloadClick: () => void;
}

const SampleRerunReport = (props: Props): JSX.Element => {
  const { salgoStartDate, bufferDate, onDownloadClick } = props;
  const today = buildNow()().toISOString();
  const classes = useStyles();
  const activeLink = salgoStartDate <= today && today <= bufferDate;

  return (
    <>
      <StyledTooltip
        arrow={true}
        placement='top'
        title='The report is only available for a series between Sample Selection Date and Series Buffer Date'
        enterDelay={200}
        display={!activeLink}
      >
        <span>
          <LinkButton
            onClick={onDownloadClick}
            dataQaId='sample-report'
            endIcon={false}
            passedClassName={classes.root}
            disabled={!activeLink}
          >
            View and download sample selection amendment report for series
          </LinkButton>
        </span>
      </StyledTooltip>
      <ExplanatoryText data-qa-id='sample-report-explanatory-text'>
        This report allows users to review where additional marks have been received after sampling has first been run.
        Differences are highlighted on the report. Appropriate action may then be taken to address changes to the sample
        by either re-running the algorithm or by manually amending the candidates within the sample
      </ExplanatoryText>
    </>
  );
};

export default SampleRerunReport;
